'use client'

import { useState } from 'react'
import { LuChevronLeft, LuX } from 'react-icons/lu'
import { Box, ButtonGroup, Drawer, Portal } from '@chakra-ui/react'
import { ProductCategory } from '@leid/api-products'

import CategoryMenuItemLink from '../CategoryLink'
import { getCategoryButton, getCategoryName } from '../utils/categories'

type Props = {
  category: ProductCategory
  allCategories: ProductCategory[]
  closeAll: () => void
}

const MobileCategoryMenuItem = ({ category, allCategories, closeAll }: Props): JSX.Element => {
  const [isOpened, setIsOpened] = useState(false)

  const childrenCategories = allCategories.filter((s) => s.parentCategoryId === (category ? category.id : undefined))

  const handleOpen = () => {
    setIsOpened(true)
  }

  const handleClose = () => {
    setIsOpened(false)
  }

  const handleCloseAll = () => {
    setIsOpened(false)
    closeAll()
  }

  return (
    <>
      {childrenCategories.length !== 0 ? (
        <>
          <Drawer.Root size={'full'} placement={'end'} open={isOpened}>
            <Drawer.Trigger width="100%" _hover={{ backgroundColor: 'leid.lightGrnn' }} onClick={handleOpen}>
              {getCategoryButton(category, childrenCategories.length !== 0)}
            </Drawer.Trigger>

            <Portal>
              <Drawer.Backdrop />
              <Drawer.Positioner>
                <Drawer.Content>
                  <Drawer.Header>
                    <Drawer.CloseTrigger pos="initial" onClick={handleClose}>
                      <button style={{ cursor: 'pointer' }}>
                        <LuChevronLeft size={32} />
                      </button>
                    </Drawer.CloseTrigger>
                    <Drawer.Title>{getCategoryName(category)}</Drawer.Title>
                    <ButtonGroup>
                      <button style={{ cursor: 'pointer' }} onClick={handleCloseAll}>
                        <LuX size={32} />
                      </button>
                    </ButtonGroup>
                  </Drawer.Header>
                  <Drawer.Body>
                    {childrenCategories.map((s) => (
                      <MobileCategoryMenuItem
                        key={s.id}
                        category={s}
                        allCategories={allCategories}
                        closeAll={handleCloseAll}
                      />
                    ))}
                  </Drawer.Body>
                </Drawer.Content>
              </Drawer.Positioner>
            </Portal>
          </Drawer.Root>
        </>
      ) : (
        <Box _hover={{ backgroundColor: 'leid.lightGrnn' }} onClick={handleCloseAll}>
          <CategoryMenuItemLink category={category} allCategories={allCategories} onClick={handleCloseAll} />
        </Box>
      )}
    </>
  )
}

export default MobileCategoryMenuItem
